import Vue from 'vue';

const requireComponent = require.context('./basecomponents', false, /Bn[\w]+\.vue/);

requireComponent.keys().forEach((element) => {
    const componentConfig = requireComponent(element);
    const componentName = element.replace(/^\.\//, '').replace(/\.\w+$/, '');

    Vue.component(componentName, componentConfig.default || componentConfig);
});
